import React, { Component } from 'react';
import './Button.scss';

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = e => {
    e.preventDefault();
    this.props.onClick();
  };

  render() {
    return (
      <button
        onClick={this.handleClick}
        className={this.props.type === 'ghost' ? 'primary-btn--ghost' : 'primary-btn'}
      >
        {this.props.text}
      </button>
    );
  }
}

export default Button;
